module.exports = __webpack_public_path__ + "static/media/featureIcon.31fc71e6.webp";